import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "format-list-numbered",
  "use": "format-list-numbered-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"format-list-numbered\"><path fill-rule=\"evenodd\" d=\"M4 17v.5H3v1h1v.5H2v1h3v-4H2v1h2Zm0-9V4H2v1h1v3h1Zm-.2 3L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1h1.8ZM7 7h14V5H7v2Zm14 12v-2H7v2h14Zm0-6v-2H7v2h14Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol